// Libs
import { createAsyncThunk } from '@reduxjs/toolkit';
// Others
import googleApi from '~/apis/google';
import {
  CONNECT_GOOGLE,
  DISCONNECT_GOOGLE,
  GET_AUTH_URL_GOOGLE,
  GET_LIST_GOOGLE_GMAIL,
  GET_TOKEN_GOOGLE,
  SEND_GOOGLE_GMAIL,
} from '~/utils/constants/actionType';
import { IQueryGetListGoogleGmail } from '~/utils/interface/email';
import { IQueryGetTokenGoogle } from '~/utils/interface/google';

export const getAuthUrlGoogle = createAsyncThunk(GET_AUTH_URL_GOOGLE, async () => {
  try {
    const res = await googleApi.getAuthUrl();
    return res.data.data;
  } catch (error) {
    throw error;
  }
});

export const getTokenGoogle = createAsyncThunk(GET_TOKEN_GOOGLE, async (payload: IQueryGetTokenGoogle) => {
  try {
    const res = await googleApi.getTokenGoogle(payload);
    return res.data;
  } catch (error) {
    throw error;
  }
});

export const connectGoogleGmail = createAsyncThunk(CONNECT_GOOGLE, async (payload: IQueryGetTokenGoogle) => {
  try {
    const res = await googleApi.connect(payload);
    return res.data;
  } catch (error) {
    throw error;
  }
});

export const disconnectGoogleGmail = createAsyncThunk(DISCONNECT_GOOGLE, async () => {
  try {
    const res = await googleApi.disconnect();
    return res.data;
  } catch (error) {
    throw error;
  }
});

export const getListGoogleGmail = createAsyncThunk(
  GET_LIST_GOOGLE_GMAIL,
  async (params: IQueryGetListGoogleGmail, { rejectWithValue }) => {
    try {
      const res = await googleApi.getListGoogleGmail(params);
      return res.data;
    } catch (error) {
      throw rejectWithValue(error);
    }
  }
);

export const sendGoogleGmail = createAsyncThunk(
  SEND_GOOGLE_GMAIL,
  async (body: FormData, { rejectWithValue }) => {
    try {
      const res = await googleApi.sendGoogleGmail(body);
      return res.data;
    } catch (error) {
      throw rejectWithValue(error);
    }
  }
);
